import "moment/locale/fr";

import moment from "moment";

import {
  RestaurantClosingRulesType,
  RestaurantOpeningHoursType,
} from "../../../../../../api/types/restaurant.type";
import { translationsContent } from "../../../../../../localization/translations";
import { useLanguage } from "../../../../../../store/lang.context";
import { translate } from "../../../../../../utils/translate";
import classes from "./item.module.scss";

interface Props {
  openingHours: RestaurantOpeningHoursType[];
  closingRules: RestaurantClosingRulesType[];
}

const isBetween = (number: number, left: number, right: number) =>
  number >= left && number <= right;

let openingHoursList: RestaurantOpeningHoursType[] = [];

const OpeningHours = ({ openingHours, closingRules }: Props) => {
  const { language } = useLanguage();

  openingHoursList = openingHours;

  const closingHoursList = closingRules
    .filter(
      (rule) =>
        isBetween(
          moment(rule.start).set({ hour: 0 }).diff(moment(new Date()), "days"),
          0,
          7
        ) ||
        isBetween(
          moment(rule.end).set({ hour: 0 }).diff(moment(new Date()), "days"),
          0,
          7
        )
    )
    .map((rule) => {
      if (Math.abs(moment(rule.start).diff(moment(rule.end), "hours")) === 24)
        return `${moment(rule.start).locale(language).format("Do MMM YYYY")}`;
      if (Math.abs(moment(rule.start).diff(moment(rule.end), "hours")) > 24)
        return `${moment(rule.start)
          .locale(language)
          .format("Do MMM YYYY")} - ${moment(rule.end)
          .locale(language)
          .format("Do MMM YYYY")}`;
      return `${moment(rule.start)
        .locale(language)
        .format("Do MMM YYYY")} ${moment(rule.start)
        .locale(language)
        .format("HH:mm")} - ${moment(rule.end)
        .locale(language)
        .format("HH:mm")}`;
    });

  for (let i = 0; i < openingHoursList.length; i++) {
    for (let j = i + 1; j < openingHoursList.length; j++) {
      if (
        openingHoursList[i].weekday_display ===
        openingHoursList[j].weekday_display
      )
        openingHoursList[j].weekday_display = "";
    }
  }

  return (
    <>
      <div className={classes.list}>
        {openingHours.map((hours, i) => (
          <p key={i} className={classes.container}>
            <span>{hours.weekday_display}</span>
            <span>
              {hours.from_hour} - {hours.to_hour}
            </span>
          </p>
        ))}
        {closingHoursList.length > 0 && (
          <>
            <p className={[classes.container, classes.closed].join(" ")}>
              <span>
                {translate(translationsContent, "closedFrom", language)}:
              </span>
            </p>
            {closingHoursList.map((closing) => (
              <p
                className={[classes.container, classes.closed].join(" ")}
                key={closing}
              >
                {closing}
              </p>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default OpeningHours;
